import apiClient from "@/app/api/client";
import { attendanceMapEndpoints } from "@/app/api/endpoints";
import type {
	AttendanceMapLiveParams,
	AttendanceMapLivePoint,
	AttendanceMapLiveResponse,
} from "../types";

export const attendanceMapService = {
	async getLive(params?: AttendanceMapLiveParams): Promise<AttendanceMapLivePoint[]> {
		const response = await apiClient.get<AttendanceMapLiveResponse>(attendanceMapEndpoints.live, {
			params,
		});
		return response.data.data;
	},
};
